import {Enumeration} from './enumeration';

export class HitAdminUiEnums extends Enumeration {
  static MODEL = [
    {id: 'APLICOM_A9_NEX', key: 'hit-admin.tracker.models.aplicom-a9-nex'},
    {id: 'APLICOM_A11_BX', key: 'hit-admin.tracker.models.aplicom-a11-bx'},
    {id: 'TELTONIKA_FMP100', key: 'hit-admin.tracker.models.teltonika-fmp100'},
    {id: 'TELTONIKA_FMC001', key: 'hit-admin.tracker.models.teltonika-fmc001'},
    {id: 'TELTONIKA_FMC130', key: 'hit-admin.tracker.models.teltonika-fmc130'},
    {id: 'TELTONIKA_FMB202', key: 'hit-admin.tracker.models.teltonika-fmb202'},
    {id: 'TELTONIKA_FMC003', key: 'hit-admin.tracker.models.teltonika-fmc003'},
    {id: 'VERSA_VTRACK', key: 'hit-admin.tracker.models.versa-vtrack'},
    {
      id: 'EM_MICROELECTRONIC_EMBP01',
      key: 'hit-admin.tracker.models.em-microelectronic-embp01',
    },
  ];

  static CATEGORY = [
    {id: 'IOT', key: 'hit-admin.tracker.categories.iot'},
    {id: 'NORMAL', key: 'hit-admin.tracker.categories.normal'},
    {id: 'BLUETOOTH', key: 'hit-admin.tracker.categories.bluetooth'},
  ];

  static BADGING_TYPE = [
    {
      id: 'TME_1-H0-05-M12',
      key: 'hit-admin.tracker.badging-types.tme-1-h0-05-m12',
    },
    {
      id: 'TELTONIKA_BADGE_READER',
      key: 'hit-admin.tracker.badging-types.teltonika-badge-reader',
    },
    {id: 'PROMAG_MF7', key: 'hit-admin.tracker.badging-types.promag-mf7'},
    {id: 'PROMAG_GP20', key: 'hit-admin.tracker.badging-types.promag-gp20'},
    {
      id: 'APLICOM_IBUTTON_READER',
      key: 'hit-admin.tracker.badging-types.aplicom-ibutton-reader',
    },
  ];

  /** Statuses that can be set manually from the admin UI. */
  static MANUAL_STATUS_IDS = [
    'RECEIVED_FROM_SUPPLIER',
    'CONFIGURED',
    'SHIPPED',
    'RETURNED_TO_US',
    'RETURNED_TO_SUPPLIER',
  ];

  static STATUS = [
    {
      id: 'RECEIVED_FROM_SUPPLIER',
      key: 'hit-admin.tracker.statuses.received-from-supplier',
    },
    {id: 'CONFIGURED', key: 'hit-admin.tracker.statuses.configured'},
    {id: 'SHIPPED', key: 'hit-admin.tracker.statuses.shipped'},
    {
      id: 'FIRST_POSITION_RECEIVED',
      key: 'hit-admin.tracker.statuses.first-position-received',
    },
    {
      id: 'FIRST_IGN_ON_RECEIVED',
      key: 'hit-admin.tracker.statuses.first-ign-on-received',
    },
    {
      id: 'FIRST_IGN_OFF_RECEIVED',
      key: 'hit-admin.tracker.statuses.first-ign-off-received',
    },
    {
      id: 'FIRST_IDENT_RECEIVED',
      key: 'hit-admin.tracker.statuses.first-ident-received',
    },
    {id: 'RETURNED_TO_US', key: 'hit-admin.tracker.statuses.returned-to-us'},
    {
      id: 'RETURNED_TO_SUPPLIER',
      key: 'hit-admin.tracker.statuses.returned-to-supplier',
    },
    {id: 'DEACTIVATED', key: 'hit-admin.tracker.statuses.deactivated'},
    {id: 'ACTIVATED', key: 'hit-admin.tracker.statuses.activated'},
    {id: 'ITEM_LINKED', key: 'hit-admin.tracker.statuses.item-linked'},
    {id: 'COMPANY', key: 'hit-admin.tracker.statuses.company'},
    {
      id: 'CUSTOMER_FIRST_POSITION_RECEIVED',
      key: 'hit-admin.tracker.statuses.customer-first-position-received',
    },
    {
      id: 'CUSTOMER_FIRST_IGN_ON_RECEIVED',
      key: 'hit-admin.tracker.statuses.customer-first-ign-on-received',
    },
    {
      id: 'CUSTOMER_FIRST_IGN_OFF_RECEIVED',
      key: 'hit-admin.tracker.statuses.customer-first-ign-off-received',
    },
    {
      id: 'CUSTOMER_FIRST_IDENT_RECEIVED',
      key: 'hit-admin.tracker.statuses.customer-first-ident-received',
    },
    {id: 'SETTING_UPDATE', key: 'hit-admin.tracker.statuses.setting-update'},
    {id: 'ORIGIN_CHANGED', key: 'hit-admin.tracker.statuses.origin-changed'},
    {
      id: 'TRACKER_AUTOMATIC_RESET',
      key: 'hit-admin.tracker.statuses.tracker-automatic-reset',
    },
  ];
}
